import { render, staticRenderFns } from "./cages-bottles.vue?vue&type=template&id=0e4ca11c&scoped=true"
import script from "./cages-bottles.vue?vue&type=script&lang=js"
export * from "./cages-bottles.vue?vue&type=script&lang=js"
import style0 from "./cages-bottles.vue?vue&type=style&index=0&id=0e4ca11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4ca11c",
  null
  
)

export default component.exports